import script from "./HistoryTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryTasks.vue?vue&type=script&setup=true&lang=js"

import "./HistoryTasks.vue?vue&type=style&index=0&id=8ba91b44&lang=scss&scoped=true"

import exportComponent from "C:\\AQ_Repo\\customermanagedinspection_fe - Brandsäkra Norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ba91b44"]])

export default __exports__